<template>
  <v-app id="xipp" :style="cssTheme">
    <template>
      <msg />
      <router-view name="container" :class="{ 'quote-css': isQuoteRoute }"></router-view>
      <keep-alive>
        <router-view name="containerkeepalive"></router-view>
      </keep-alive>
    </template>
    <v-footer class="mt-1 d-flex justify-center" color="footer">
      Powered by Xipp &copy; {{ new Date().getFullYear() }}
    </v-footer>
  </v-app>
</template>

<script>
import msg from "./components/structure/msgv2.vue";
import { mapMutations } from "vuex";

export default {
  watch: {
    routeQueryTheme: {
      deep: true,
      handler(theme) {
        this.setTheme();
      }
    }
  },
  methods: {
    ...mapMutations(["updateMenuState", "updateStructure"]),
    setTheme() {
      let themeParam = this.$route.query.theme;
      if (!themeParam) {
        const theme = sessionStorage.getItem("theme");
        themeParam = theme || 'light';
      }
      sessionStorage.setItem("theme", themeParam);
      this.$themes.applyTheme(themeParam);
    },
  },
  computed: {
    routeQueryTheme() {
      return this.$route && this.$route.query && this.$route.query.theme;
    },
    cssTheme() {
      // espaço da barra de menu inferiro
      const heightBottom = this.$util.isIosMobile()
        ? "75px"
        : this.$util.isMobile()
        ? "60px"
        : "36px";
      const paddingBottom = this.$util.isIosMobile() ? "5px" : "0px";
      this.updateStructure({ heightBottom, paddingBottom });

      const out = {};
      out["--v-heightBottom"] = heightBottom;
      out["--v-paddingBottom"] = paddingBottom;

      for (const name of Object.keys(this.$vuetify.theme.themes.light))
        out["--v-" + name] = this.$vuetify.theme.themes.light[name];

      return out;
    },
    isQuoteRoute() {
      return this.$route.fullPath && (this.$route.fullPath.includes('calculate-quote')
        || this.$route.fullPath.includes('quote-form') || this.$route.fullPath.includes('dashboard-quote')
        || this.$route.fullPath.includes('home'));
    }
  },
  components: { msg },
};
</script>
